module.exports = "/_next/static/images/empty-vessel-data-icon-6dd857d58de2a2453cb208e38ac42da9.svg";